
import Vue from "vue";
import { mapFields } from "vuex-map-fields";
import { DinMisstankeText, VilkenRollText } from "@/store/map";
import { KvittensSession } from "@/store/types";
import FkObservationerSammanfattning from "@/views/Containers/FkObservationerSammanfattning.vue";
import FkKontaktuppgifterSammanfattning from "@/views/Containers/FkKontaktuppgifterSammanfattning.vue";
import { SessionService } from "@/services/SessionService";

export default Vue.extend({
    name: "PrintedDocument",
    components: {
        FkObservationerSammanfattning,
        FkKontaktuppgifterSammanfattning,
    },
    data: () => ({
        DinMisstankeText,
        session: null as null | KvittensSession,
        VilkenRollText,
    }),
    computed: {
        ...mapFields(["forsteg.vilkenroll", "forsteg.misstanke"]),
    },
    created() {
        this.session = SessionService.getKvittensSession();
    },
});
